import { useTranslation } from "react-i18next";
import {
  enumAgenctStatusList,
  enumCommentGrievanceStatusFlowStatus,
  enumCommentStatusFlowStatus,
  enumStarScoreFlowStatus,
} from "../../../types/enums/status";

export const useLookupLists = () => {
  const { t } = useTranslation();

  const starScoreLookupList = [
    {
      id: enumStarScoreFlowStatus.one,
      value: "1",
    },
    {
      id: enumStarScoreFlowStatus.two,
      value: "2",
    },
    {
      id: enumStarScoreFlowStatus.three,
      value: "3",
    },
    {
      id: enumStarScoreFlowStatus.four,
      value: "4",
    },
    {
      id: enumStarScoreFlowStatus.five,
      value: "5",
    },
  ];

  const agentStatusList = [
    {
      id: enumAgenctStatusList.all,
      value: t("general.all"),
    },
    {
      id: enumAgenctStatusList.yes,
      value: t("general.yes"),
    },
    {
      id: enumAgenctStatusList.no,
      value: t("general.no"),
    },
  ];

  const grievanceStatusSelectBoxLookupList = [
    {
      id: enumCommentGrievanceStatusFlowStatus.two,
      value: t("general.all"),
    },
    {
      id: enumCommentGrievanceStatusFlowStatus.one,
      value: t("general.var"),
    },
    {
      id: enumCommentGrievanceStatusFlowStatus.zero,
      value: t("general.giderildi"),
    },
  ];
  const grievanceStatusLookupList = [
    {
      id: enumCommentGrievanceStatusFlowStatus.two,
      value: "-",
    },
    {
      id: enumCommentGrievanceStatusFlowStatus.one,
      value: t('general.var'),
    },
    {
      id: enumCommentGrievanceStatusFlowStatus.zero,
      value: t('general.giderildi'),
    }
  ];
  const commentStatusLookupList = [
    {
      id: enumCommentStatusFlowStatus.minusOne,
      value: t('general.all'),
      name: t('general.all'),
    },
    {
      id: enumCommentStatusFlowStatus.one,
      value: t('general.waitingForApproval'),
      name: t('general.waitingForApproval'),
    },
    {
      id: enumCommentStatusFlowStatus.two,
      value: t('general.approved'),
      name: t('general.approved'),
    },
    {
      id: enumCommentStatusFlowStatus.three,
      value: t('general.declined'),
      name: t('general.declined'),
    },
  ];
  
  const enumCommentStatusFlowStatusTrName: any = {
    [enumCommentStatusFlowStatus.minusOne]: "Tümü",
    [enumCommentStatusFlowStatus.one]: "Onay Bekliyor",
    [enumCommentStatusFlowStatus.two]: "Onaylandı",
    [enumCommentStatusFlowStatus.three]: "Reddedildi",
  };
  return {
    starScoreLookupList,
    agentStatusList,
    grievanceStatusSelectBoxLookupList,
    commentStatusLookupList,
    grievanceStatusLookupList,
    enumCommentStatusFlowStatusTrName
  };
};
